
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { ContentDto, LogoContent } from 'fourwaves-shared';

@Component({})
export default class LogosContentBlock extends Vue {
  @Prop({ required: true }) content!: ContentDto;

  get logos(): LogoContent[] {
    if (this.content.data && this.transl8(this.content.data)) {
      return JSON.parse(this.transl8(this.content.data)) as LogoContent[];
    }
    return [];
  }
}
